export default "__VITE_ASSET__D08Mq_Nw__"